import { Box, Typography } from '@mui/material'
import React from 'react'
import Styles from '../Config/Styles'
import ButtonBox from './Button'
import { BUYMATERIAL } from '../Routes/constURL'
import { useNavigate } from 'react-router-dom'

const Empty = ({ name }) => {
    const navigate = useNavigate()
    return (
        <Box sx={Styles.empty.box}>
            <img src={require('../assets/mycart.png')} />
            <Typography sx={Styles.empty.text}>No {name}</Typography>
            <Typography sx={Styles.empty.text1}>Raise a new RFQ to create an order</Typography>
            <Box sx={Styles.empty.btn}>
                <ButtonBox color={"black"} text={"Buy Material"} textcolor={"white"} onClick={() => navigate(BUYMATERIAL)} />
            </Box>
        </Box>)
}

export default Empty